/**
 * @module business 
 *  Apis must need auth details to trigger url - AuthApi
 */

import Env from '@/env';
const apiVersion = 'api/v1';
import AuthApis from '@/controllers/AuthApis';
import ApiHelper from '@/controllers/ApiHelpers';

export default {
  /**
   * List all program categories with product
   */
  programCount(program_id) {
    const url = `${Env.loyaltyUrl}/${apiVersion}/programs/${program_id}/products/count`;
    return AuthApis.getApi(url, null)
      .then(res => res)
      .catch(err => {
        ApiHelper.detectStatusAndRedirect(err);
        return err;
      });
  },

  /**
   * add program product
   */
  addProgramProductAction(program_id, data) {
    const url = `${Env.loyaltyUrl}/${apiVersion}/programs/${program_id}/products`;
    return AuthApis.postApi(url, null, data)
      .then(res => res)
      .catch(err => {
        ApiHelper.detectStatusAndRedirect(err);
        return err;
      });
  },


}